// @flow
import React, { useContext } from 'react';

import config from 'Config';
import { addTranslationKeys } from 'Src/i18n';
import ReactAppContext from 'Context/ReactAppContext';
import ReactResponsiveContext from 'Components/utils/responsive/responsiveContext';
import { Wibilong } from 'Components/widgets/wibilong/Wibilong.jsx';

import {
  mapCommunityQuestions,
  type ProductCommunityQuestionsLineProps,
} from './productCommunityQuestionsLine.utils';

const WIBILONG_ENABLED = config.get('social.wibilong.enabled');

export const ProductCommunityQuestionsLine = (props: ProductCommunityQuestionsLineProps) => {
  const appContext = useContext(ReactAppContext);
  const { isAppMounted } = useContext(ReactResponsiveContext);
  addTranslationKeys(props.config);

  const hasCommunityQuestions = Boolean(props.productCommunity.questions.length);
  const isDisplayed = WIBILONG_ENABLED && isAppMounted && hasCommunityQuestions;
  if (!isDisplayed) {
    return null;
  }

  const popinButton = {
    country: appContext.country.toUpperCase(),
    language: appContext.language.toUpperCase(),
    productId: props.resortId,
  };
  const communityQuestionsProps = mapCommunityQuestions({ ...props, popinButton });
  return (
    <div className="Line">
      <Wibilong {...communityQuestionsProps} />
    </div>
  );
};
